import { COUNTRIES } from "./countries";

export enum SAmericaVessels {
  MV13 = "MV13",
  MV42 = "MV42",
  MV60 = "MV60",
}

export enum NAmericaVessels {
  MV51 = "MV51",
}

export enum NSeaVessels {
  MV43 = "MV43",
}

export enum SeAsiaVessels {
  MV63 = "MV63",
}

export enum OceaniaVessels {
  MV68 = "MV68",
}

export enum WAfricaVessels {
  MV77 = "MV77",
}

export const vessels = [
  {
    city: "FPSO Shape 3",
    country_code: COUNTRIES.S_AMERICA,
    vessel_code: SAmericaVessels.MV13,
  },
  {
    city: "FPSO Shape 1",
    country_code: COUNTRIES.S_AMERICA,
    vessel_code: SAmericaVessels.MV42,
  },
  {
    city: "FPSO Shape 2",
    country_code: COUNTRIES.S_AMERICA,
    vessel_code: SAmericaVessels.MV60,
  },
  {
    city: "FPSO Shape 4",
    country_code: COUNTRIES.N_AMERICA,
    vessel_code: NAmericaVessels.MV51,
  },
  {
    city: "FPSO Shape 5",
    country_code: COUNTRIES.N_SEA,
    vessel_code: NSeaVessels.MV43,
  },
  {
    city: "FPSO Shape 7",
    country_code: COUNTRIES.SE_ASIA,
    vessel_code: SeAsiaVessels.MV63,
  },
  {
    city: "FPSO Shape 8",
    country_code: COUNTRIES.OCEANIA,
    vessel_code: OceaniaVessels.MV68,
  },
  {
    city: "FPSO Shape 6",
    country_code: COUNTRIES.W_AFRICA,
    vessel_code: WAfricaVessels.MV77,
  },
];

export const getCityByVessel = (vesselId: string) =>
  vessels.find((vessel) => vessel.vessel_code === vesselId)?.city;

export const getCountryByVessel = (vesselId: string) =>
  vessels.find((vessel) => vessel.vessel_code === vesselId)?.country_code;

export const getVesselsByCountry = (
  country: string | string[] | null | undefined,
) =>
  country
    ? vessels.filter((vessel) => vessel.country_code === country)
    : vessels;
